import React, { useEffect, useState } from "react";
import Drop from "./items/Drop";
import userDropsApi from "../../api/awardApi";

export default function Drops() {
    const [drops, setDrops] = useState([]);

    useEffect(() => {
        const getDrops = async () => {
            try {
                const response = await userDropsApi.getUserDrops(1, 10);
                console.log('🟡 Drops API raw response:', response);

                let items = [];
                // API вернул массив
                if (Array.isArray(response)) {
                    items = response;
                }
                // API вернул { items: [] }
                else if (Array.isArray(response?.items)) {
                    items = response.items;
                }
                // API вернул { data: [] }
                else if (Array.isArray(response?.data)) {
                    items = response.data;
                }

                console.log('🟡 Drops parsed items:', items);
                setDrops(items);
            } catch (err) {
                console.error('🔴 Drops API error:', err);
            }
        };

        getDrops();
    }, []);

    return (
        <div className="w-full flex flex-col px-[10px] pt-[10px] gap-[10px] min-h-[180px]">
            {drops.length === 0 ? (
                <div className="w-full py-16 flex items-center justify-center">
                    <span className="text-white/50 text-[14px]">No Drops Yet</span>
                </div>
            ) : (
                drops.map((drop, i) => (
                    <Drop
                        key={drop?.id ?? i}
                        drop={drop}
                    />
                ))
            )}
        </div>
    );
}
